import React from "react";
import { useAppDispatch } from "../..";
import withMapService, { MapServiceProps } from "../../HOCs/withMapService";
import { setLoadingStatus } from "../../store/reducers/map";
import {
  Button,
  TrackLocationButtonWrap
} from "./styles/TrackYourLocationStyles";

const TrackMyLocation = (props: MapServiceProps) => {
  const dispatch = useAppDispatch();

  const getCurrentLocalization = () => {
    dispatch(setLoadingStatus({ isLoading: true }));
    props.trackMyLocation();
  };

  return (
    <TrackLocationButtonWrap>
      <Button onClick={getCurrentLocalization}>
        Namierz swoją lokalizację
      </Button>
    </TrackLocationButtonWrap>
  );
};

export default withMapService(TrackMyLocation);
